var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebcamOffIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_608",
    "data-name": "Union 608",
    d: "M22.793,20.707,18.3,16.214v.067A3.214,3.214,0,0,1,15.094,19.5H3.218A3.219,3.219,0,0,1,0,16.287V6.712A3.216,3.216,0,0,1,3.212,3.5H5.585L3.793,1.707A1,1,0,0,1,5.207.293l19,19a1,1,0,0,1-1.415,1.414Zm3.37-2.795a1.12,1.12,0,0,1-.58-.169l-2.5-1.581-3.152-3.151V9.131a.533.533,0,0,1,.25-.45l5.406-3.413a1.072,1.072,0,0,1,.58-.168h1.3A.535.535,0,0,1,28,5.631v11.75a.535.535,0,0,1-.537.531ZM18.3,11.384,10.415,3.5h4.673A3.216,3.216,0,0,1,18.3,6.712v4.674Z",
    fill: "#85888a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcamOffIcon);
export default __webpack_public_path__ + "static/media/WebcamOffIcon.97eb6038d105c5f1e934ac94fcb8445a.svg";
export { ForwardRef as ReactComponent };